import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchSsoOrganizations } from '@/api/(admin)/sso';
import type { SsoOrganization } from '@/api/(admin)/sso/types';

/** Prefix for every SSO cache entry — what a write invalidates. */
export const ssoQueryKey = ['admin', 'sso'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export const ssoOrganizationsQueryOptions = () =>
  queryOptions({
    queryKey: [...ssoQueryKey, 'organizations'] as const,
    queryFn: fetchSsoOrganizations,
  });

export function useSsoOrganizations() {
  const query = useQuery(ssoOrganizationsQueryOptions());
  const rows: SsoOrganization[] = query.data?.data ?? [];
  return { ...query, rows };
}
